import * as angular from "angular";
import { ConstantsService } from "./constantsService";

export interface IDialogOptionsJson {
    title?: string;
    afterTitle?: string;
    dialogHTML: string;
    dialogId: string;
    bindings?: any;
    escapeToClose?: boolean;
    clickOutsideToClose?: boolean;
    event?: MouseEvent;
    preventFocusOnOpen?: boolean;
    customClass?: string;
    multiple?: boolean;
    fullScreen?: boolean;
    preventFullScreenOnMobile?: boolean;
    hideXCloseButton?: boolean;
}

export class DisplayService {

    static $inject = ["$mdDialog", "$mdToast", "constantsService"];

    constructor(
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly $mdToast: angular.material.IToastService,
        private readonly constantsService: ConstantsService) {
    }

    showMessage(message: string, position?: string, hideDelay?: number): void {
        if (!position) {
            position = "bottom right";
        }

        if (hideDelay !== 0) {
            hideDelay = 3000;
        }

        this.$mdToast.show(
            this.$mdToast.simple()
                .textContent(message)
                .position(position)
                .hideDelay(hideDelay)
        );
    }

    showMessageWithTemplate(template: string, hideDelay: number, position: string, parent: string): void {

        this.$mdToast.show({
            template: template,
            hideDelay: hideDelay,
            position: position,
            parent: parent
        });
    }

    showDialog(dialogOptionsJson: IDialogOptionsJson): angular.IPromise<any> {
        const controller = ($mdDialog) => {

            dialogOptionsJson.bindings = dialogOptionsJson.bindings || {};
            dialogOptionsJson.bindings.hide = () => { $mdDialog.hide(); };

            return dialogOptionsJson.bindings;
        };

        controller.$inject = ["$mdDialog"];

        const dialogOptions: angular.material.IDialogOptions = {
            focusOnOpen: !dialogOptionsJson?.preventFocusOnOpen,
            targetEvent: dialogOptionsJson?.event,
            escapeToClose: dialogOptionsJson?.escapeToClose,
            multiple: dialogOptionsJson?.multiple,
            clickOutsideToClose: dialogOptionsJson?.clickOutsideToClose,
            template: this.createDialogWrapper(dialogOptionsJson),
            fullscreen: dialogOptionsJson.fullScreen,
            controller: controller,
            controllerAs: "$ctrl"
        };


        return this.$mdDialog.show(dialogOptions);
    }

    createDialogWrapper(dialogOptionsJson: IDialogOptionsJson) {
        const isMobile = this.constantsService.getIsMobile();
        let customClass = dialogOptionsJson?.customClass || '';

        if (dialogOptionsJson.fullScreen) {
            customClass += " fullscreen";
        }

        const mobileClass = (!dialogOptionsJson.preventFullScreenOnMobile && isMobile) ? 'mobile' : '';
        const hideXCloseButton = dialogOptionsJson?.hideXCloseButton;

        return `<md-dialog aria-label="Edit tags"
                    id="${dialogOptionsJson.dialogId}"
                    class="${customClass} ${mobileClass}">
                <md-toolbar>
                    <div class="md-toolbar-tools">
                        <h2>${dialogOptionsJson.title}</h2>

                            ${dialogOptionsJson.afterTitle || ""}

                            <span flex></span>
                            <md-button ng-if="${!hideXCloseButton}" class="md-icon-button" ng-click="$ctrl.hide()">
                                <md-icon>clear</md-icon>
                            </md-button>
                        </div>
                    </md-toolbar>

              ${dialogOptionsJson.dialogHTML}
            </md-dialog>`;
    }
}
